import angular from 'angular';
import corporateTeamModal from './corporateTeamModal';
import './style.scss';

export default angular
  .module('components.corporateTeamModal', [])
  .component('corporateTeamModal', corporateTeamModal).name;
